export default __webpack_public_path__ + "static/media/SocialMusicDiscovery.0fdbebe1.svg";